import {Geolocator} from 'hegyd/core/resources/assets/js/utils/Geolocator.js'

export default class AddressesForm extends HTMLDivElement {

    constructor() {
        super();

        this.latitudeField = document.getElementById('latitude');
        this.longitudeField = document.getElementById('longitude');
        this.mapContainer = document.getElementById('map-container');
    }

    connectedCallback() {
        var self = this;
        window.onload = function()
        {
            self.map = self.mapContainer.getMap();
            self.init();
            self.initMapEvents();
        }
    }

    init() {
        /**
         * Set initial marker
         */
        if (this.latitudeField.value && this.longitudeField.value) {
            this.addMarker();
        }
    }

    initMapEvents() {
        var self = this;
        this.map.addEventListener('click', function (e) {
            /**
             * Get Lat Lng from click e
             */
            var clickLat = e.latlng.lat;
            var clickLng = e.latlng.lng;

            /**
             * Add values to fields
             */
            self.setLatLngFields(clickLat.toFixed(10), clickLng.toFixed(10));
            self.addMarker();
        });

        this.querySelector('.js-search-address')
            .addEventListener('click', function (e) {
                e.preventDefault();
                self.searchAddress();
            });
    }

    setLatLngFields(latitude, longitude) {
        this.latitudeField.value = latitude;
        this.longitudeField.value = longitude;
    }

    searchAddress() {
        var self = this;
        var address = '';
        address += self.querySelector('.address').value + '+';
        address += self.querySelector('.city').value + '+';
        address += self.querySelector('.zip').value + '+';
        address += self.querySelector('.country').selectedOptions[0].text;

        var geolocator = new Geolocator();
        geolocator.searchPositionWithOpenStreetMap(address, function (data) {
            if (data[0] !== undefined) {
                data = data[0];
            }
            var Lat = data.lat;
            var Lng = data.lon;

            if (Lat === null || Lng === null || Lat === undefined || Lng === undefined) {
                toastr.error('Addresse non trouvée');
            } else {
                self.setLatLngFields(parseFloat(Lat).toFixed(10), parseFloat(Lng).toFixed(10));
                self.addMarker();

            }
        });
    }

    addMarker(){
        this.mapContainer.addMarkers([
            {
                'latitude': this.latitudeField.value,
                'longitude': this.longitudeField.value,
            }
        ])
    }
}